/**
 * The single mutable input record shared between the control layer and the
 * game loop.
 *
 * Controls WRITE, gameplay READS. Keeping this as one plain object (rather than
 * having controls reach into the game) means a new input device - gyroscope,
 * touch, gamepad - only ever has to produce this same shape.
 */
export interface InputState {
  /** Desired board angular velocity from keyboard / drag input, rad/s. */
  omegaTarget: number;

  /**
   * When non-null this OVERRIDES every physical input device.
   *
   * It exists so the automated verification harness can drive the board at an
   * exact angular velocity; it is also the hook a future "auto-rotate" demo
   * mode would use.
   */
  forcedOmega: number | null;

  /** Set to true to request a ball reset. The game loop clears it once handled. */
  resetRequested: boolean;
}

export function createInputState(): InputState {
  return {
    omegaTarget: 0,
    forcedOmega: null,
    resetRequested: false,
  };
}
